<template>
  <div class="time-sheet-base">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "timeSheetBase",
};
</script>
